import { Dialog } from 'primereact/dialog'
import { useTranslation } from 'react-i18next'
import MainTaskDetailView from './MainTaskDetailView'
import '../../minutes/minutes.css'
import '../../meetings/meetings.css'
import '../actions.css'

interface Props {
  /** Ana görevin kimliği (alt görevin `parentId`'si). */
  actionId: number
  visible: boolean
  onHide: () => void
}

/**
 * <b>Ana Görevi Gör</b> popup'ı (kullanıcı isteği 2026-09-10) — alt görevin sorumlusu, ana görevin
 * detayını <b>salt-okuma</b> görür. Yalnız alt görev oluşturulurken "atanan ana görevi de görebilsin"
 * işaretlenmişse açılır; kutuyu ve kapsam kuralını {@code SubActionDetailPage} + {@code ActionViewScope}
 * yönetir, bu bileşen kapı DEĞİLDİR (uç zaten kapsam dışında 404 döner).
 *
 * <p><b>Neden popup, ayrı sayfa değil:</b> kullanıcı isteği. Sayfaya gidilseydi alt görev bağlamı
 * kapanır, "Geri" ile dönmek gerekirdi; popup ana görevi bağlamı kaybetmeden gösterir.
 *
 * <p><b>Neden Görev Detay sayfası yeniden kullanılmadı:</b> o sayfa düzenleme, statü değiştirme,
 * not/dosya ekleme, alt görev yönetimi ve termin talebi akışlarını taşır — hepsi bu kullanıcıya
 * kapalıdır. Sayfayı popup içine koymak, sunucunun {@code editable=false} bayrağına dayanan onlarca
 * koşulu ikinci bir bağlamda doğru çalışmaya zorlardı; tek bir kaçak, salt-okuma sözünü bozardı.
 *
 * <p><b>105 — gövde ortaklaştırıldı.</b> Popup artık yalnız bir kabuktur; gösterdiği her şey
 * {@link MainTaskDetailView}'dan gelir. Aynı görünümü Toplantı Yönetimi'ndeki <b>Yeniden Açma</b>
 * pop-up'ının sağ bölmesi de kullanır (spec FR-036) — iki yüzeyin ayrışması böylece yapısal olarak
 * imkânsızdır. Kopya sayısı <b>artmadı, azaldı</b>: bu dosyadaki JSX ortak bileşene taşındı.
 *
 * <p>Veri <b>yalnız popup açıkken</b> çekilir ({@code active={visible}}) — {@code
 * ActionHistoryDialog} ile aynı desen: kapalı popup ağ isteği üretmez.
 */
export default function MainTaskViewDialog({ actionId, visible, onHide }: Readonly<Props>) {
  const { t } = useTranslation()

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t('actions.detail.subActionPage.mainTaskDialog.title')}
      modal
      dismissableMask
      draggable={false}
      className="act-maintask-dialog"
      style={{ width: '60rem', maxWidth: '95vw' }}
    >
      <MainTaskDetailView actionId={actionId} active={visible} />
    </Dialog>
  )
}
